import posts from '../content/journal.generated.json';
export function getJournalPosts() { return posts; }
export function getJournalPost(slug) { return posts.find(post => post.slug === slug) || null; }
